import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function Reality() {
  return <section aria-labelledby="reality-heading" className="border-b border-navy-700 bg-navy-900" data-id="element-151" data-mp="25vx4znh6ti1l">
      <div className="mx-auto grid max-w-page gap-8 px-4 py-12 sm:px-5 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20 lg:py-24" data-id="element-152" data-mp="21vwrc51wxavl">
        <div data-id="element-153" data-mp="1wxv73gsr35ij">
          <h2 id="reality-heading" className="font-display text-2xl font-extrabold leading-[1.08] tracking-[-0.03em] text-white sm:text-4xl" data-id="element-154" data-mp="1wu7dkhnb2j3t">
            The reality of teaching blues
          </h2>
          <p className="mt-4 text-[15px] text-mist sm:mt-5 sm:text-base" data-id="element-155" data-mp="2kl3blwicuaji">
            Professional teacher? Does this sound familiar?
          </p>
          <p className="mt-8 border-l-4 border-gold pl-4 font-display text-lg font-bold leading-snug text-gold sm:pl-5 sm:text-2xl lg:mt-10" data-id="element-156" data-mp="2fma029mmotlz">
            How much longer are you willing to just “wing it”?
          </p>
        </div>

        <ul className="divide-y divide-navy-700 border-y border-navy-700" data-id="element-157" data-mp="s122hy7fglc2">
          {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-4" data-id="element-158" data-mp="w35i8z14qc35">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-steel" aria-hidden="true" strokeWidth={3} data-id="element-159" data-mp="w0ay78m12ta9" />
              <span className="text-[15px] leading-relaxed text-mist" data-id="element-160" data-mp="n0e58uslv89e">{point}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}